// extracted by mini-css-extract-plugin
export default {"plan_block":"plan_block___bz_1Q","buttons_block":"buttons_block___pwUNZ","plus":"plus___DOpys"};